<template>
  <div class="visit-time-slot-grid">
    <VisitTimeSlotGroup label="morning"
                        :slots="morning"
                        :value="value"
                        :readonly="readonly"
                        @select="select"/>
    <VisitTimeSlotGroup label="afternoon"
                        :slots="afternoon"
                        :value="value"
                        :readonly="readonly"
                        @select="select"/>
    <VisitTimeSlotGroup label="evening"
                        :slots="evening"
                        :value="value"
                        :readonly="readonly"
                        @select="select"/>
  </div>
</template>

<script setup>
import {computed} from "vue"
import VisitTimeSlotGroup from "@/components/parts/calendar/visitmodal/VisitTimeSlotGroup.vue"

const props = defineProps({
  value: {
    type: String,
    default: null
  },
  slots: {
    type: Array,
    default: () => []
  },
  duration: {
    type: Number,
    default: null
  },
  readonly: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['select'])

const hour = (s) => parseInt((s.start || '0').split(':')[0])
const toMinutes = (t) => {
  const [h, m] = t.split(':').map(Number)
  return h * 60 + m
}
const contiguousEnd = (ind) => {
  const end = props.slots[ind].end
  const next = props.slots[ind + 1]
  if(!next || next.start !== end) return end
  return contiguousEnd(ind + 1)
}
const fitsDuration = (ind) => {
  if(!props.duration) return true
  return toMinutes(props.slots[ind].start) + props.duration <= toMinutes(contiguousEnd(ind))
}

const fittingSlots = computed(() => props.slots.filter((s, ind) => fitsDuration(ind)))

const morning = computed(() => fittingSlots.value.filter(s => hour(s) < 12))
const afternoon = computed(() => fittingSlots.value.filter(s => hour(s) >= 12 && hour(s) < 18))
const evening = computed(() => fittingSlots.value.filter(s => hour(s) >= 18))

const select = (s) => {
  emit('select', s)
}
</script>
